import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchPrepaidTripFailure,
  fetchPrepaidTripSuccess,
  type PrepaidData,
} from "../slices/prepaidSlice";
import { StatusCodes } from "http-status-codes";
import { request } from "src/utils/api";
import { FETCH_PREPAID_TRIP } from "../actions/PrepaidTripAction";
import notification from "antd/es/notification";

export function* fetchhPrepaidTripSaga(action: any): Generator<any, void, any> {
  try {
    const result: any = yield call(request, action.payload);
    if (result.status == StatusCodes.OK)
      yield put(fetchPrepaidTripSuccess(result));
    else {
      yield put(fetchPrepaidTripFailure(result.message));
      notification.error({
        message: "Data Failed",
        description: result.message,
        placement: "topRight",
        showProgress: true,
      });
    }
  } catch (error: any) {
    yield put(fetchPrepaidTripFailure(error.message));
  }
}

// function* watchFetchTripData() {
//   yield takeLatest(fetchData.type, fetchTripData);
// }

export default function* corporatetripSaga() {
  yield takeLatest(FETCH_PREPAID_TRIP, fetchhPrepaidTripSaga);
}
